import { formatNumber } from "../lib/format";

// Shared Prev/Next paging control (phase 4 amendment) — used by AuditPage
// and CoveragePage's two tabs, all three built against the same
// limit/cursor/total/next_cursor contract (api/usePagedFetch.ts). A plain
// button pair rather than numbered pages: the contract only ever exposes a
// forward cursor, and "Prev/Next" reads honestly against that rather than
// implying random-access page numbers the backend can't actually serve.
//
// `total` is optional (added for the Packets page, 2026-09-20): GET
// /api/packets?limit=&before= is a bare array with no count of any kind —
// when `total` is omitted the range shows on its own, honestly, rather
// than claiming an "of N" the endpoint never provided.
export function PagingBar({
  rangeStart,
  rangeEnd,
  total,
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  note,
}: {
  rangeStart: number;
  rangeEnd: number;
  total?: number;
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  note?: string;
}) {
  return (
    <div className="paging-bar">
      <button type="button" onClick={onPrev} disabled={!hasPrev}>
        Prev
      </button>
      <button type="button" onClick={onNext} disabled={!hasNext}>
        Next
      </button>
      <span>
        {rangeStart === 0 ? "0" : `${formatNumber(rangeStart)}-${formatNumber(rangeEnd)}`}
        {total != null ? ` of ${formatNumber(total)}` : ""}
      </span>
      {note && <span className="paging-bar-note">{note}</span>}
    </div>
  );
}
